import { TTypographyVariant } from "../../../types";
import { ProgressCircleSize } from "./types";

type ProgressRingSizeStylesMap = {
    size: number;
    strokeWidth: number;
};

type ProgressLabelSizeMap = {
    label: TTypographyVariant;
    sublabel: TTypographyVariant;
};

/**
 * @internal
 */
export const showOutsideLabel = (size: ProgressCircleSize): boolean => {
    const outsideLabelSizes: ProgressCircleSize[] = ["xs", "sm"];
    return outsideLabelSizes.includes(size);
};

/**
 * @internal
 */
export const getProgressCircleSizeStyles = (size: ProgressCircleSize): ProgressRingSizeStylesMap => {
    switch (size) {
        case "lg":
            return {
                size: 200,
                strokeWidth: 24
            };
        case "md":
            return {
                size: 160,
                strokeWidth: 20
            };
        case "sm":
            return {
                size: 120,
                strokeWidth: 16
            };
        case "xs":
        default:
            return {
                size: 64,
                strokeWidth: 6
            };
    }
};

/**
 * @internal
 */
export const getProgressLabelSizes = (size: ProgressCircleSize): ProgressLabelSizeMap => {
    switch (size) {
        case "lg":
            return {
                label: "heading-regular-medium",
                sublabel: "label-small-medium"
            };
        case "md":
            return {
                label: "heading-small-medium",
                sublabel: "label-x-small-medium"
            };
        case "sm":
            return {
                label: "label-large-medium",
                sublabel: "label-x-small-medium"
            };
        case "xs":
        default:
            return {
                label: "label-x-small-medium",
                sublabel: "label-x-small-medium"
            };
    }
};
